// @flow
import React, { Component, Fragment } from "react";

import ExpiresColorLabel from "../../components/licences/ExpiresColorLabel";
import LicenceTypeLabel from "../../components/licences/LicenceTypeLable";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Link from "@material-ui/core/Link";

type LicenceItemTablePropsType = {
  licence: { [key: string]: * },
  isAdmin?: boolean,
  displayCompany?: boolean,
  isLicenceAdmin?: boolean,
  isImagusAdmin?: boolean,
  isHistory?: boolean,
  downloadFile?: Function
};

class LicenceItemTable extends Component<LicenceItemTablePropsType, *> {
  render(): * {
    const licence = this.props.licence;
    const isPoDisplay =
      (this.props.isLicenceAdmin || this.props.isHistory) && licence.poFile;
    const isDisplayModules = this.props.isImagusAdmin && !!licence.modules;

    return (
      <Table className="app-table no-border" style={{ width: "auto" }}>
        <TableBody>
          <TableRow className="slim">
            {this.props.isHistory ? (
              <Fragment>
                <TableCell className="border compact" padding="dense">
                  Update on
                </TableCell>
                <TableCell className="compact normal" padding="dense">
                  {licence.createDate}
                </TableCell>
                <TableCell className="border compact" padding="dense">
                  Update By
                </TableCell>
                <TableCell className="compact normal" padding="dense">
                  {licence.createdBy}
                </TableCell>
                <TableCell className="border compact" padding="dense" />
                <TableCell className="compact normal" padding="dense" />
              </Fragment>
            ) : (
              <Fragment>
                <TableCell className="border compact" padding="dense">
                  System Name
                </TableCell>
                <TableCell className="compact normal" padding="dense">
                  {licence.facebaseName}
                </TableCell>
                <TableCell className="border compact" padding="dense">
                  Number of Faces
                </TableCell>
                <TableCell className="compact normal" padding="dense">
                  {licence.facebaseLimit}
                </TableCell>
                <TableCell className="border compact" padding="dense">
                  Slots
                </TableCell>
                <TableCell className="compact normal" padding="dense">
                  {licence.slotsUsed} assigned | {licence.slotsAvail} of{" "}
                  {licence.slotsTotal} available
                </TableCell>
              </Fragment>
            )}
          </TableRow>
          <TableRow className="slim">
            <TableCell className="border compact" padding="dense">
              Started On
            </TableCell>
            <TableCell className="compact normal" padding="dense">
              {licence.startDate}
            </TableCell>
            <TableCell className="border compact" padding="dense">
              {licence.expiryMinutes < 0 ? "Expired On" : "Expires In"}
            </TableCell>
            <TableCell className="compact normal" padding="dense">
              <ExpiresColorLabel
                expiryDate={licence.expiryDate}
                expiryMinutes={licence.expiryMinutes}
                exact={true}
                extentDate={licence.extentDate}
              />
            </TableCell>
            <TableCell className="border compact" padding="dense">
              Auto Assign
            </TableCell>
            <TableCell className="compact normal" padding="dense">
              {String(licence.autoAssign)}
            </TableCell>
          </TableRow>
          <TableRow className="slim">
            <TableCell className="border compact" padding="dense">
              Licence Type
            </TableCell>
            <TableCell className="compact normal" padding="dense">
              <LicenceTypeLabel licenceType={licence.licenceType} />
            </TableCell>
            <TableCell className="border compact" padding="dense">
              Number of Cameras
            </TableCell>
            <TableCell className="compact normal" padding="dense">
              {licence.noOfStreams}
            </TableCell>
            {this.props.isAdmin && (
              <Fragment>
                <TableCell className="border compact" padding="dense">
                  Created On
                </TableCell>
                <TableCell className="compact normal" padding="dense">
                  {licence.createDate}
                </TableCell>
              </Fragment>
            )}
            {this.props.isHistory && (
              <Fragment>
                <TableCell className="border compact" padding="dense">
                  Number of Slots
                </TableCell>
                <TableCell className="compact normal" padding="dense">
                  {licence.noOfSlots}
                </TableCell>
              </Fragment>
            )}
          </TableRow>
          {isDisplayModules && (
            <TableRow className="slim">
              <TableCell className="border compact" padding="dense">
                Modules
              </TableCell>
              <TableCell className="compact normal" padding="dense" colSpan={5}>
                {licence.modules.map((module: *, i: number): * => (
                  <div key={i}>
                    {module.name + " (" + module.version + "): " + module.data}
                  </div>
                ))}
              </TableCell>
            </TableRow>
          )}
          {this.props.isAdmin && (
            <TableRow className="slim">
              <TableCell className="border compact" padding="dense">
                Created By
              </TableCell>
              <TableCell className="compact normal" padding="dense">
                {licence.createdBy}
              </TableCell>
              <TableCell className="border compact" padding="dense">
                Last Update on
              </TableCell>
              <TableCell className="compact normal" padding="dense">
                {licence.updatedDate}
              </TableCell>
              <TableCell className="border compact" padding="dense">
                Last Update By
              </TableCell>
              <TableCell className="compact normal" padding="dense">
                {licence.updatedBy}
              </TableCell>
            </TableRow>
          )}
          {this.props.displayCompany && (
            <TableRow className="slim">
              <TableCell className="border compact" padding="dense">
                Company Name
              </TableCell>
              <TableCell className="compact normal" padding="dense">
                {licence.company.name}
              </TableCell>
              <TableCell className="border compact" padding="dense">
                Company UUID
              </TableCell>
              <TableCell className="compact normal" padding="dense">
                {licence.company.uuid}
              </TableCell>
              <TableCell className="border compact" padding="dense">
                Authorised Reseller
              </TableCell>
              <TableCell className="compact normal" padding="dense">
                {String(licence.authorisedReseller)}
              </TableCell>
            </TableRow>
          )}
          {isPoDisplay && (
            <TableRow className="slim">
              <TableCell className="border compact" padding="dense">
                PO File
              </TableCell>
              <TableCell className="compact normal" padding="dense" colSpan={5}>
                <Link
                  style={{ cursor: "pointer" }}
                  onClick={this.props.downloadFile(
                    this.props.isHistory ? licence.id : null
                  )}
                >
                  {licence.poFile}
                </Link>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    );
  }
}

export default LicenceItemTable;
